import React from "react";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import PaginationWrapper from "@visa/vds/pagination-wrapper";
import SearchResultItem from "./SearchResultItem";
import { PageHelper } from "../../../_helpers/PageHelper";

const SearchList = (props) => {
    const searchResults = props.searchResults;
    const pageSize = props.pageSize;
    const totalCount = props.totalCount;
    const selectedPage = props.selectedPage;

    const totalPages = PageHelper.GetTotalCountToPages(props.pageSize, totalCount);
    const startCount = (selectedPage - 1) * pageSize + 1;
    const endCount = searchResults ? (selectedPage - 1) * pageSize + searchResults.length : 0;

    return (
        <>
            <Row>
                <Col>
                    {searchResults.map((item, k) => (
                        <SearchResultItem key={k}
                            item={item}
                            handleClickItem={props.handleClickItem}
                        />
                    ))}
                </Col>
            </Row>
            <Row>
                <Col>
                    Showing {startCount} to {endCount} of {totalCount}{" "} entries
                </Col>
            </Row>
            <Row>
                <Col>
                    <PaginationWrapper
                        ariaLabel="Paging for Search Results"
                        onButtonClick={(e, page) => {
                            props.setSelectedPage(page);
                        }}
                        selectedPage={selectedPage}
                        totalPages={totalPages}
                    />
                </Col>
            </Row>
        </>
    );
}
export default SearchList;